const dayMonthDateFormat = new Intl.DateTimeFormat('en-US', {
  weekday: 'long',
  month: 'long',
  day: 'numeric',
  timeZone: 'UTC',
})
export const formatDayMonthDate = (isoDate: string) =>
  dayMonthDateFormat.format(Date.parse(isoDate))

const dayShortMonthDateFormat = new Intl.DateTimeFormat('en-US', {
  weekday: 'long',
  month: 'short',
  day: 'numeric',
  timeZone: 'UTC',
})
export const formatDayShortMonthDate = (isoDate: string) =>
  dayShortMonthDateFormat.format(Date.parse(isoDate))

const monthDateFormat = new Intl.DateTimeFormat('en-US', {
  month: 'long',
  day: 'numeric',
  timeZone: 'UTC',
})
export const formatMonthDate = (isoDate: string) =>
  monthDateFormat.format(Date.parse(isoDate))
